module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.109c02a6.ttf";